import { Currencies } from 'types/currency';

export const getPriceWithDecimals: ({
    price,
    decimals,
}: {
    price: number;
    decimals?: number;
    currency?: string;
}) => string = ({ price, decimals = 2, currency }) => {
    if (currency === Currencies.CLP) return String(price);

    const priceValue = price / 100;

    return priceValue.toFixed(decimals);
};

export const getCurrenciesSign = (currency: string): string =>
    new Intl.NumberFormat('en', { style: 'currency', currency })
        .formatToParts(1)
        .find((part) => part.type === 'currency')?.value || currency;
